import { render } from "./TimeTableGroupClass.vue?vue&type=template&id=7f294e71"
import script from "./TimeTableGroupClass.vue?vue&type=script&lang=js"
export * from "./TimeTableGroupClass.vue?vue&type=script&lang=js"

import "./TimeTableGroupClass.vue?vue&type=style&index=0&id=7f294e71&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__